import React from 'react';

const FullPageLayout = ({children}) => {

  // const { Content } = Layout;

  return (
    <div>
      <main className="main text-muted">{children}</main>
    </div>
  );
}

export default FullPageLayout;